import { Check } from 'lucide-react';
import { Input } from '../../ui/input';

const LABEL_OPTIONS = ['Home', 'Office', 'Other'];

export default function AddressFormFields({
  selectedLocation,
  label,
  setLabel,
  streetAddress,
  setStreetAddress,
  showDetails,
  province,
  onProvinceChange,
  city,
  onCityChange,
  barangay,
  setBarangay,
  zipCode,
  setZipCode,
  provinces,
  cities,
  barangays
}) {
  return (
    <>
      {/* Location indicator */}
      {selectedLocation.lat && (
        <div className="flex items-center gap-2 text-sm text-green-600 bg-green-50 px-3 py-2 rounded-lg">
          <Check className="w-4 h-4" />
          Location pinned: {selectedLocation.lat.toFixed(6)}, {selectedLocation.lng.toFixed(6)}
        </div>
      )}

      {/* Label - always visible */}
      <div>
        <label className="text-xs font-medium text-stone-600">Label *</label>
        <div className="flex gap-2 mt-1 flex-wrap">
          {LABEL_OPTIONS.map((l) => (
            <button
              key={l}
              type="button"
              onClick={() => setLabel(l)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${
                label === l
                  ? 'bg-slate-900 text-white'
                  : 'bg-stone-100 text-stone-700 hover:bg-stone-200'
              }`}
            >
              {l}
            </button>
          ))}
          <Input
            placeholder="Custom label"
            value={!LABEL_OPTIONS.includes(label) ? label : ''}
            onChange={(e) => setLabel(e.target.value)}
            className="flex-1 min-w-[100px] h-9"
          />
        </div>
      </div>

      {/* Street Address - always visible */}
      <div>
        <label className="text-xs font-medium text-stone-600">Street Address / Building / Unit *</label>
        <Input
          placeholder="e.g., 123 Main St, Unit 4B, ABC Building"
          value={streetAddress}
          onChange={(e) => setStreetAddress(e.target.value)}
          className="mt-1 h-11"
          data-testid="street-input"
        />
      </div>

      {/* Extended details */}
      {showDetails && (
        <>
          <div>
            <label className="text-xs font-medium text-stone-600">Province / Region</label>
            <select
              value={province}
              onChange={(e) => onProvinceChange(e.target.value)}
              className="w-full mt-1 h-11 px-3 rounded-md border border-stone-200 bg-white"
            >
              <option value="">Select Province</option>
              {provinces.map((p) => (
                <option key={p} value={p}>{p}</option>
              ))}
            </select>
          </div>

          <div>
            <label className="text-xs font-medium text-stone-600">City / Municipality *</label>
            <select
              value={city}
              onChange={(e) => onCityChange(e.target.value)}
              className="w-full mt-1 h-11 px-3 rounded-md border border-stone-200 bg-white"
            >
              <option value="">Select City</option>
              {cities.map((c) => (
                <option key={c} value={c}>{c}</option>
              ))}
            </select>
          </div>

          <div>
            <label className="text-xs font-medium text-stone-600">Barangay</label>
            <select
              value={barangay}
              onChange={(e) => setBarangay(e.target.value)}
              className="w-full mt-1 h-11 px-3 rounded-md border border-stone-200 bg-white"
            >
              <option value="">Select Barangay</option>
              {barangays.map((b) => (
                <option key={b} value={b}>{b}</option>
              ))}
            </select>
          </div>

          <div>
            <label className="text-xs font-medium text-stone-600">Zip Code</label>
            <Input
              placeholder="e.g., 1234"
              value={zipCode}
              onChange={(e) => setZipCode(e.target.value)}
              className="mt-1 h-11"
            />
          </div>

          <div className="h-4" aria-hidden="true" />
        </>
      )}
    </>
  );
}
